import React from "react";

// Contenu du tutoriel de l'écran "Feuille de temps" — étapes (image + titre
// + description) affichées par le composant générique TutorialOverlay
// (src/components/ui/TutorialOverlay.js). "image" est volontairement vide
// pour l'instant : captures d'écran à ajouter ensuite, slide par slide.
const feuilleTempsTutorial = [
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20143808.png",
    title: "Vue générale et ajout d'une saisie",
    legende: "",
    description: (
      <>
        Naviguez entre les jours avec les flèches, le calendrier ou le
        bouton <strong>« Aujourd'hui »</strong> — le badge indique si la
        journée est <strong>en cours</strong>, <strong>à venir</strong> ou{" "}
        <strong>clôturée</strong>, avec le total d'heures saisies.
        <br />
        <br />
        En bas de la liste, ajoutez une ligne en choisissant un{" "}
        <strong>dossier</strong> (ou « Interne » si aucun dossier), le
        nombre d'<strong>heures</strong> et une <strong>description</strong>{" "}
        — modifiable ou supprimable tant que la journée n'est pas clôturée.
      </>
    ),
  },
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20143818.png",
    title: "La clôturation",
    legende: "",
    description: (
      <>
        Une fois vos saisies terminées, cliquez sur{" "}
        <strong>« Clôturer la journée »</strong> — impossible si aucune
        ligne n'a été saisie.
        <br />
        <br />
        Choisissez, si besoin, un ou plusieurs{" "}
        <strong>collaborateurs à notifier</strong> par mail (facultatif),
        puis confirmez : la journée se <strong>verrouille</strong> (plus de
        modification possible) et un mail part automatiquement aux
        personnes choisies.
        <br />
        <br />
        Une journée déjà clôturée peut toujours être{" "}
        <strong>renvoyée / notifiée</strong> à d'autres collaborateurs par la
        suite — seule la saisie reste verrouillée.
      </>
    ),
  },
];

export default feuilleTempsTutorial;
